import React from 'react';
import { Box, Typography } from '@mui/material';
import SectionTitle from './shared/SectionTitle';

const TransparentPricingSection: React.FC = () => {
    return (
        <Box>
            <SectionTitle centered sx={{ mb: 3 }}>
                Premium Sails Without Premium-Brand Pricing
            </SectionTitle>

            <Typography
                variant="body1"
                align="center"
                sx={{
                    maxWidth: '800px',
                    margin: '0 auto',
                    mb: 4,
                    fontSize: { xs: '1rem', sm: '1.063rem' },
                    lineHeight: 1.7,
                    color: 'text.secondary'
                }}
            >
                Our sails are built in a respected international loft that also produces sails
                for major brands. We keep our prices lower by staying lean: no big-box marketing
                campaigns and no retail showrooms. You get the same quality tier, without the overhead.
            </Typography>

            <Typography
                variant="body1"
                align="center"
                sx={{
                    fontStyle: 'italic',
                    fontSize: '1.063rem',
                    fontWeight: 500,
                    color: 'primary.main',
                    mt: 3
                }}
            >
                "If we wouldn't be happy sailing with it ourselves, we won't ship it."
            </Typography>
        </Box>
    );
};

export default TransparentPricingSection;
